import { render, staticRenderFns } from "./FooterView.vue?vue&type=template&id=035751b0&scoped=true"
import script from "./FooterView.vue?vue&type=script&lang=js"
export * from "./FooterView.vue?vue&type=script&lang=js"
import style0 from "./FooterView.vue?vue&type=style&index=0&id=035751b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035751b0",
  null
  
)

export default component.exports